import React from 'react';
import MainLayout from '../layouts/MainLayout';

const Dashboard = () => {
  const qualityMetrics = [
    { name: "Defeitos/milhão", value: 245, target: 300, trend: "down" },
    { name: "Custo de não-qualidade", value: "R$ 157.432", target: "R$ 200.000", trend: "down" },
    { name: "% Análises no prazo", value: "87%", target: "90%", trend: "up" },
    { name: "Eficácia das ações", value: "76%", target: "80%", trend: "stable" }
  ];
  
  const topDefects = [
    { name: "Vazamento", count: 32, percentage: 23 },
    { name: "Falha elétrica", count: 28, percentage: 20 },
    { name: "Ruído excessivo", count: 25, percentage: 18 },
    { name: "Vibração", count: 19, percentage: 14 }
  ];
  
  const rootCauseCategories = [
    { category: "Máquina", count: 67, percentage: 38 },
    { category: "Método", count: 42, percentage: 24 },
    { category: "Material", count: 31, percentage: 18 },
    { category: "Mão-de-obra", count: 18, percentage: 10 }
  ];
  
  const recentOccurrences = [
    { id: "OC-2025-0489", product: "Válvula de Controle A-370", defect: "Vazamento na vedação", severity: 4, date: "20/05/2025", status: "Em análise" },
    { id: "OC-2025-0488", product: "Sensor de Pressão X-290", defect: "Falha de calibração", severity: 3, date: "19/05/2025", status: "Aberto" },
    { id: "OC-2025-0487", product: "Bomba Centrífuga BC-450", defect: "Vibração excessiva", severity: 5, date: "18/05/2025", status: "Em análise" }
  ];

  return (
    <MainLayout>
      <h2 className="text-2xl font-bold mb-6">Dashboard</h2>
      
      {/* KPI Cards */}
      <div className="grid grid-cols-4 gap-6 mb-8">
        {qualityMetrics.map((metric, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-6">
            <h3 className="text-gray-500 text-sm font-medium mb-2">{metric.name}</h3>
            <div className="flex items-center">
              <div className="text-3xl font-bold mr-2">{metric.value}</div>
              <div className="flex items-center">
                {metric.trend === "up" && (
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd"></path>
                  </svg>
                )}
                {metric.trend === "down" && (
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1v-5a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586l-4.293-4.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clipRule="evenodd"></path>
                  </svg>
                )}
                {metric.trend === "stable" && (
                  <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clipRule="evenodd"></path>
                  </svg>
                )}
              </div>
            </div>
            <div className="text-sm text-gray-500 mt-1">Meta: {metric.target}</div>
          </div>
        ))}
      </div>
      
      <div className="grid grid-cols-2 gap-6 mb-6">
        {/* Top Defects */}
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold mb-4">Principais Defeitos</h3>
          <div>
            {topDefects.map((defect, index) => (
              <div key={index} className="mb-3">
                <div className="flex justify-between mb-1">
                  <span>{defect.name}</span>
                  <span className="text-gray-600">{defect.count} ({defect.percentage}%)</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${defect.percentage}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Root Cause Categories */}
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold mb-4">Categorias de Causa Raiz</h3>
          <div>
            {rootCauseCategories.map((category, index) => (
              <div key={index} className="mb-3">
                <div className="flex justify-between mb-1">
                  <span>{category.category}</span>
                  <span className="text-gray-600">{category.count} ({category.percentage}%)</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div className="bg-indigo-600 h-2.5 rounded-full" style={{ width: `${category.percentage}%` }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Recent Occurrences Table */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-semibold">Ocorrências Recentes</h3>
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">Ver todas</button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 text-xs font-medium text-gray-500 uppercase">
              <tr>
                <th className="py-3 px-4 text-left">ID</th>
                <th className="py-3 px-4 text-left">Produto</th>
                <th className="py-3 px-4 text-left">Defeito</th>
                <th className="py-3 px-4 text-left">Sev.</th>
                <th className="py-3 px-4 text-left">Data</th>
                <th className="py-3 px-4 text-left">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {recentOccurrences.map((occurrence, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="py-2 px-4 text-sm font-medium text-blue-600">{occurrence.id}</td>
                  <td className="py-2 px-4 text-sm">{occurrence.product}</td>
                  <td className="py-2 px-4 text-sm">{occurrence.defect}</td>
                  <td className="py-2 px-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      occurrence.severity >= 4 ? 'bg-red-100 text-red-800' : 
                      occurrence.severity === 3 ? 'bg-yellow-100 text-yellow-800' : 
                      'bg-green-100 text-green-800'
                    }`}>
                      {occurrence.severity}
                    </span>
                  </td>
                  <td className="py-2 px-4 text-sm">{occurrence.date}</td>
                  <td className="py-2 px-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      occurrence.status === 'Aberto' ? 'bg-blue-100 text-blue-800' : 
                      occurrence.status === 'Em análise' ? 'bg-purple-100 text-purple-800' : 
                      'bg-green-100 text-green-800'
                    }`}>
                      {occurrence.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;